import { type FC } from "react";

interface StarActiveIconProps {
  active: boolean;
  size?: "small" | "large";
}

const StarActiveIcon: FC<StarActiveIconProps> = ({ active, size = "large" }) => {
  const [fill, stroke] = active ? ["#FAC515", "#FAC515"] : ["transparent", "#475467"];
  const iconSize = size === "large" ? "size-7" : "size-5";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 28 28"
      fill="none"
      className={iconSize}
    >
      <path
        d="M13.163 4.029c.269-.545.403-.817.586-.904a.583.583 0 0 1 .502 0c.182.087.317.36.586.904l2.55 5.168c.08.161.12.241.178.304.051.055.113.1.181.132.078.036.166.049.344.075l5.706.834c.601.087.902.131 1.04.278a.583.583 0 0 1 .155.478c-.026.2-.244.412-.679.836l-4.127 4.02c-.129.125-.193.188-.235.263a.582.582 0 0 0-.07.213c-.01.085.006.174.036.35l.974 5.68c.103.598.154.898.058 1.075a.583.583 0 0 1-.407.295c-.199.037-.468-.104-1.005-.387l-5.102-2.683c-.159-.084-.238-.125-.322-.142a.585.585 0 0 0-.225 0c-.083.017-.163.058-.322.142l-5.101 2.683c-.538.283-.807.424-1.006.387a.583.583 0 0 1-.406-.295c-.097-.177-.045-.477.057-1.076l.974-5.678c.03-.178.046-.266.036-.35a.583.583 0 0 0-.07-.214c-.041-.075-.106-.138-.234-.263l-4.128-4.02c-.435-.424-.653-.636-.679-.836a.583.583 0 0 1 .155-.478c.139-.147.44-.19 1.04-.278l5.707-.834c.177-.026.266-.04.343-.075a.584.584 0 0 0 .182-.132c.058-.063.097-.143.177-.304l2.55-5.168Z"
        fill={fill}
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="transition-all duration-200"
      />
    </svg>
  );
};

export default StarActiveIcon;
